import styled from 'styled-components'

import { Search } from 'media/icons'

export const StyledRoot = styled.div`
		${({ isInTable, isInverted }) => (isInTable || isInverted) ? `
	 input[type=text] { 
			background-color: #efefef;
		}
		` : ''}
		position: relative;
		width: 100%;
		box-shadow: none !important;
`

export const StyledInput = styled.input`
		max-width: unset!important;
		width: 100%;
		height: 40px;
		margin: 0;
		box-shadow: none;
`

export const StyledSearchIco = styled(Search)`
		font-size: 15px;
		position: absolute;
		right: 10px;
		top: 50%;
		transform: translateY(-50%);
		path {
			fill: #c3c3c3;
		}
`
